<mat-form-field class="chip-list pt-16 px-16">
    <mat-label>{{labelString}}</mat-label>
    <mat-chip-grid #chipList aria-label="Partners selection">
        <mat-chip-row *ngFor="let item of selectedItems;let indx=index;" 
            [selectable]="selectable" 
            [removable]="canRemove(item)" 
            (removed)="remove(item,indx)">
            {{item.description || item.assistantDescription}}
            <mat-icon matChipRemove *ngIf="canRemove(item)">cancel</mat-icon>
        </mat-chip-row>
        <input #groupInput 
            [disabled]="!canAddColab()" 
            [formControl]="chipCtrl" 
            [matAutocomplete]="auto" 
            [matChipInputFor]="chipList" 
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" 
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="add($event)" 
            (focusout)="colabLostFocus()">
        <mat-spinner *ngIf="isLoading.value" matSuffix diameter="16" style="display: inline-flex"></mat-spinner>
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" 
        (optionSelected)="selected($event)" autoActiveFirstOption>
        <mat-option *ngFor="let item of clientAutoComplete$ | async; let index = index" [value]="item">
            {{ item.description | titlecase}}
        </mat-option>
    </mat-autocomplete>
    <mat-hint class="error" *ngIf="chipControlFormError">{{'COLLABSCHIP.ASIST-REQ' | translate}}!</mat-hint>
</mat-form-field>